// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"search_searchInputWrapper__CICCv","searchInput":"search_searchInput__ht9jC"};